export default __webpack_public_path__ + "98cfe5ae4310de8fd55a9842605241fd.woff2";